<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div class="orderSearchBox">
                    <el-input v-model="name" placeholder="服务商名称"></el-input>
                    <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
                    <el-button type="text" class="resetBtn" @click="resetData">
                        <i class="iconfont icon-qingchushujuku"></i>
                        <span>清除条件</span>
                    </el-button>
                </div>
                <div class="storeData">
                    <div class="storeData_nap">
                        <div class="storeData_napL">统计时间：{{nowDate}}</div>
                        <div class="storeData_napR">
                            <el-radio-group class="hide_input" v-model="tabPosition">
                                <el-radio-button
                                    :label="items.type"
                                    v-for="(items, index) in napList"
                                    :key="index"
                                    @click.native.prevent="selectTimeType(items.type)"
                                >
                                    {{ items.name }}
                                    <!-- 月 -->
                                    <el-date-picker
                                        v-show="items.type == 'month'"
                                        class="date"
                                        @change="dateChangeMonth"
                                        v-model="dateDay"
                                        type="month"
                                        value-format="yyyy-MM-dd"
                                    >
                                    </el-date-picker>
                                    <!-- 自定义 -->
                                    <el-date-picker
                                        v-show="items.type == 'day'"
                                        class="date"
                                        @change="dateRangeChange"
                                        v-model="dateDay"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                    >
                                    </el-date-picker>
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div class="orderListTable">
                    <el-table
                        :data="providerList"
                        border
                        @sort-change="sortChange"
                        style="width: 100%" class="tableContent">
                        <el-table-column
                            prop="name"
                            label="服务商名称"
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="goodsCount"
                            label="商品数量"
                            header-align="center"
                            show-overflow-tooltip
                            sortable
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="materialCount"
                            label="材料数量"
                            sortable
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="serviceCount"
                            label="服务数量"
                            sortable
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="visitorNumber"
                            label="访客数"
                            sortable
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="volumeNumber"
                            label="浏览量"
                            sortable
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                        </el-table-column>
                        <el-table-column
                            prop="orderCount"
                            label="订单数"
                            sortable
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                            <template slot-scope="scope">
                                {{ scope.row.materialOrderCount+scope.row.serviceOrderCount+scope.row.orderCount }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="orderPrice"
                            label="支付金额"
                            sortable
                            header-align="center"
                            show-overflow-tooltip
                            align="center">
                            <template slot-scope="scope">
                                {{ scope.row.materialOrderPrice+scope.row.serviceOrderPrice+scope.row.orderPrice }}
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        @prev-click="handleCurrentChange"
                        @next-click="handleCurrentChange"
                        layout="total,prev, pager, next,jumper"
                        :current-page="current"
                        :page-size="pageSize"
                        :total="total" class="pagination">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { findEnterPriseInfoList } from '../../utils/interface';
    export default {
        name: "designerRangliste",
        components: {},
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120;
                return {minHeight: height + 'px'}
            },
        },
        data() {
            return {
                current:1,
                pageSize:10,
                total:0,
                name:"",
                nowDate:"",
                dateDay:null,
                providerList:[],
                startDate:"",
                endDate:"",
                createDateValue:null,
                tabPosition: "nowDay",
                napList: [
                    {
                        type: "month",
                        name: "月",
                    },
                    {
                        type: "day",
                        name: "日区间",
                    },
                ],
                orderBy:"",
            }
        },
        created(){
            let templateDate = new Date();
            this.endDate = this.timeDate(new Date());
            templateDate.setDate(templateDate.getDate() - 30); // 今天的前N天的日期，N自定义
            this.startDate = templateDate.getFullYear() + '-' + (templateDate.getMonth() + 1) + '-' + templateDate.getDate();
            this.nowDate = this.startDate +"——"+ this.endDate;
        },
        mounted(){
            this.getProviderList();
        },
        methods: {
            // 分页
            handleCurrentChange(val) {
                this.current = val;
                this.getProviderList();
            },
            timeDate(value){
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? "0" + MM : MM;
                let d = date.getDate();
                d = d < 10 ? "0" + d : d;
                return y + "-" + MM + "-" + d;
            },
            selectTimeType(type) {
                this.tabPosition = type;
            },
            searchInfo(){
                this.getProviderList();
            },
            resetData(){
                this.name = "";
                this.getProviderList();
            },
            getProviderList(){
                let params = {
                    current:this.current,
                    pageSize:this.pageSize,
                    startDate:this.startDate,
                    endDate:this.endDate,
                    name:this.name,
                    orderBy:this.orderBy
                }
                findEnterPriseInfoList(params).then((res)=>{
                    this.providerList = res.list;
                    this.total = res.total;
                });
            },
            // 时间格式
            chooseDate(){
                this.startDate = "";
                this.endDate = "";
                // 判断时间
                if(this.createDateValue!=null && this.createDateValue.length==2){
                    this.startDate = this.timeDate(this.createDateValue[0]);
                    this.endDate = this.timeDate(this.createDateValue[1]);
                }
            },
            dateChangeMonth(date) {
                this.startDate = this.getCurrentMonthFirst(date);
                this.endDate = this.getCurrentMonthLast(date);
                this.nowDate = this.startDate +"——"+ this.endDate;
                this.getProviderList();
            },
            getCurrentMonthFirst(data){
                let date = new Date(data);
                date.setDate(1);
                let month = parseInt(date.getMonth()+1);
                let day = date.getDate();
                if (month < 10) {
                    month = '0' + month
                }
                if (day < 10) {
                    day = '0' + day
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            getCurrentMonthLast(data){
                let date = new Date(data);
                let currentMonth=date.getMonth();
                let nextMonth=++currentMonth;
                let nextMonthFirstDay=new Date(date.getFullYear(),nextMonth,1);
                let oneDay=1000*60*60*24;
                let lastTime = new Date(nextMonthFirstDay-oneDay);
                let month = parseInt(lastTime.getMonth()+1);
                let day = lastTime.getDate();
                if (month < 10) {
                    month = '0' + month
                }
                if (day < 10) {
                    day = '0' + day
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            dateRangeChange(date) {
                this.startDate = date[0];
                this.endDate = date[1];
                this.nowDate = this.startDate +"——"+ this.endDate;
                this.getProviderList();
            },
            sortChange(column){
                if(column&&column.order!=null) {
                    if(this.orderBy===""){
                        this.orderBy = column.prop + "_ascend";
                    }else if(this.orderBy.indexOf("ascend")>-1){
                        this.orderBy = column.prop + "_descend";
                    }else if(this.orderBy.indexOf("descend")>-1){
                        this.orderBy = column.prop + "_ascend";
                    }
                    this.current = 1;
                    this.getProviderList();
                }
            },
        }
    }

</script>

<style scoped lang="less">
.orderManagementClass {
    position: relative;
    width: 100%;
    padding: 0 20px 20px;
    .orderManagementContent {
        background: #fff;

        .printOrderListBox {
            padding: 20px;
            .orderSearchBox {
                display: flex;
                margin-bottom: 20px;
                .searchTop{
                    display: flex;
                    align-items: center;
                    margin-bottom: 22px;
                }
                .searchBottom{
                    display: flex;
                    align-items: center;
                    margin-bottom: 22px;
                }
                .searchItem{
                    display: flex;
                    align-items: center;
                    margin-right: 30px;
                    .name{
                        padding-right: 20px;
                        min-width: 100px;
                    }
                }
                /deep/ .el-input {
                    width: initial;
                }
                /deep/ .el-input__inner {
                    width: 242px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;
                    margin-right: 20px;

                    &:hover, &:focus {
                        background-color: #fff;
                        border: 1px solid #108EE9;
                    }
                }
                /deep/.el-range-editor{
                    width: 500px;
                    /deep/.el-range-input{
                        width: 242px;
                        height: 32px;
                        min-height: 32px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                    }
                    /deep/.el-range__icon,/deep/.el-range-separator,/deep/.el-range__close-icon{
                        line-height: 29px;
                    }
                    &:hover, &:focus {
                        background-color: #fff;
                        border: 1px solid #108EE9;
                        /deep/.el-range-input{
                            background-color: #fff;
                        }
                    }
                }
                /deep/ .el-input__prefix {
                    top: -3px;
                }
                /deep/ .el-input__suffix {
                    top: 2px;
                }
                /deep/ .el-button {
                    display: block;
                    line-height: 35px;
                    padding: 0;
                    height: 35px;
                }
                .searchBtn {
                    width: 82px;
                    background: #3d7fff;
                    border: none;
                    border-radius: 15px;
                    font-size: 14px;
                    color: #FFFFFF;
                }
                .resetBtn {
                    color: #333333;
                    &:hover{
                        color: #3d7fff;
                    }
                }
            }
        }
    }
}
.pagination {
    margin-top: 20px;
    text-align: right;
}
.storeData {
    background-color: #ffffff;
    padding: 20px;

    .storeData_nap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
    }
}

//隐藏的CSS代码
/*按钮日期选择器隐藏ipnut*/
.hide_input {
    position: relative !important;
}
.date{
    width: 100px;
}
//修改控件自带的css
.hide_input /deep/ .el-date-editor {
    position: absolute; //绝对定位
    top: 0;
    left: 0;
    opacity: 0; //设置完全透明
    display:unset;
}

.hide_input /deep/ .el-input__prefix {
    left: 0;
    width: 55px;
}

.storeData_pane_trad_nap {
    display: flex;
    align-items: center;
    padding: 20px;

    .trad_nap2 {
        background: rgba(147, 185, 255, 0.158);
        border-bottom: 4px solid rgb(88, 146, 253);
    }

    .trad_nap {
        padding: 20px 40px;
        font-size: 14px;
        width: 20%;
        cursor: pointer;

        &:hover {
            background: rgba(185, 210, 255, 0.158);
        }

        .trad_nap_name {
            margin-bottom: 15px;
        }

        .trad_nap_num {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .trad_nap_money {
                font-weight: bold;
            }

            .trad_nap_mess {
                color: #666;
            }

            .trad_nap_pre {
                display: flex;
                align-items: center;
                color: red;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/statistic/providerRangliste.vue